import script from "./ReferralsVisualisePage.vue?vue&type=script&setup=true&lang=ts"
export * from "./ReferralsVisualisePage.vue?vue&type=script&setup=true&lang=ts"

import "./ReferralsVisualisePage.vue?vue&type=style&index=0&id=9f3568ba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9f3568ba"]])

export default __exports__